<template>
  <div class="__control">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.__control {
  display: flex;
  width: 100%;

  // > * {
    // flex: 0 1 70%;
  // }
  > *:not(:first-child) {
    margin-left: 8px;
  }
}
</style>